/**
 * The chart's "Tags" lane — under each hour, the Tag Rules › Hours tags it
 * carries (their colours); dashed when a tag cannot judge it. Shown only
 * when an hour rule tests a tag.
 * For Media Devoted | Created By Ciro Autiero
 */
import type { FC } from 'react';
import { Tag } from 'lucide-react';

import type { HourView } from '../hour-chart-math';
import { ChartLane, HOUR_GRID } from '../chart/lanes/ChartLane';
import { HourTagDots } from './HourTagDots';

interface Props {
  rows: HourView[];
  colors?: Record<string, string>;
  onHover: (hour: number) => void;
}

export const HourTagLane: FC<Props> = ({ rows, colors, onHover }) => (
  <ChartLane icon={Tag} label="Tags" title="The hour tags each hour carries (Tag Rules › Hours) — dashed: a tag cannot judge the hour.">
    <div className="grid h-4" style={HOUR_GRID} data-testid="hour-tag-lane">
      {rows.map((row) => (
        <span key={row.hour} onMouseEnter={() => onHover(row.hour)} className="flex items-center justify-center">
          <HourTagDots row={row} colors={colors} />
        </span>
      ))}
    </div>
  </ChartLane>
);
